"use client";

import { Core } from "@faire/slate/foundation/color";
import { iconCls } from "@faire/slate/lib/tracking";
import { createSVGIconV2 } from "@faire/web/slate/icons/lib/createSVGIconV2";
import React from "react";

// Implemented using the icons from here: https://faire-wholesale.slack.com/archives/C08PZGMUC3Z/p1756238353493689?thread_ts=1756237700.863289&cid=C08PZGMUC3Z
export const Heart = createSVGIconV2(
  <path
    d="M12.9248 4.17285C15.1155 1.94225 18.6628 1.94224 20.8535 4.17285C23.049 6.40843 23.0489 10.0358 20.8535 12.2715L12 21.2861L3.14648 12.2715C0.951108 10.0358 0.950999 6.40843 3.14648 4.17285C5.33715 1.94224 8.88452 1.94225 11.0752 4.17285L11.6436 4.75195L12 5.11426L12.3564 4.75195L12.9248 4.17285Z"
    stroke="currentColor"
    strokeLinecap="round"
  />,
  "Heart",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      id: "KOuc/j",
      defaultMessage: "Save",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    color: Core.icon.primary,
    className: iconCls(),
  })
);
